import styled from 'styled-components';
import * as globals from '../css/globals.styles';

export const SearchNav = styled.div`
  position: relative;
`;

export const ExperimentalTestBar = styled.div`
  position: absolute;
  top: 0;
  left: 86px;
  right: 146px;
  z-index: 1;
  min-height: 1px;
  background-color: ${globals.gray900};
`;
